export default "__VITE_ASSET__CzIBbfWl__"